import React from 'react';
import PropTypes from 'prop-types';
import { ContentGroup, Heading, StepCounter } from 'yw-ui.v2';
import { CUSTOMER_REPRESENTATIVE } from '../../../common/constants';
import { getSteps } from '../../../common/functions/stepTracker';

const PageContentHeader = ({ pathname, representative }) => {
  const steps = getSteps(pathname, representative);
  return (
    <ContentGroup className="u-mt--300">
      <Heading priority={1} size="lg" id="page-heading_heading" className="app-page-title">
        Priority Services
      </Heading>
      <div className="c-divider" />
      {steps && <StepCounter appName="Priority Services" steps={steps} />}
    </ContentGroup>
  );
};

PageContentHeader.propTypes = {
  pathname: PropTypes.string.isRequired,
  representative: PropTypes.oneOf([CUSTOMER_REPRESENTATIVE.MYSELF, CUSTOMER_REPRESENTATIVE.SOMEONE_ELSE]).isRequired,
};

export default PageContentHeader;
